import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import {getStore, setStore} from "trim-redux";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import SubTitle from "../../../components/elements/SubTitle";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Translate} from "../../../../config/Translate";
import Button from "@material-ui/core/Button/Button";
import {currencySymbol, price} from "../../../../config/values";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import {Link} from "react-router-dom";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton/IconButton";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import NotifSound from "../../../../files/sounds/notif.mp3";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";

class SellerAnalyticsShort extends React.Component {
    state = {
        finished_inventory: null,
        finished_inventory_most_purchased: null,
        finishing_inventory: null,
        pending_orders: null,
        ready_orders: null,
        done_orders:null,
        rejected_orders:null,
        total_products:null,
        total_pending_products:null,
        total_rejected_products:null,
        shop_visits:null,
        products_visits:null,
        loading:true,
        open:false,
    };
    componentDidMount() {
        this.loadData();
        this.interval = setInterval(() => {
            this.loadData();
        }, 65000); // Runs every 60 seconds (1 minute)
    }

    componentWillUnmount() {
        clearInterval(this.interval); // Prevent memory leaks
    }

    playNotificationSound = () => {
        const audio = new Audio(NotifSound);
        let user = getStore('user');
        if(!!user.has_sound){
            audio.play().catch(error => {
                this.setState({
                    open:true
                })
            });
        }

    };
    async loadData() {
        this.setState({
            loading: true,
        });

        let loginToken = localStorage.getItem('ACT');
        if (loginToken !== null) {
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };

            await axios.get(`${defaultVariabls.url}/analytics/seller-analytics`, config)
                .then(response => {
                    const {
                        finished_inventory,
                        finishing_inventory,
                        pending_orders,
                        ready_orders,
                        finished_inventory_most_purchased,
                        done_orders,
                        rejected_orders,
                        total_products,
                        total_pending_products,
                        total_rejected_products,
                        shop_visits,
                        products_visits,
                    } = response.data;

                    // Check if any of the values increased
                    if (
                        (this.state.finished_inventory !== null && finished_inventory > this.state.finished_inventory) ||
                        (this.state.finishing_inventory !== null && finishing_inventory > this.state.finishing_inventory) ||
                        (this.state.pending_orders !== null && pending_orders > this.state.pending_orders) ||
                        (this.state.ready_orders !== null && ready_orders > this.state.ready_orders)
                    ) {
                        this.playNotificationSound();
                    }

                    this.setState({
                        prev_finished_inventory: this.state.finished_inventory,
                        prev_finishing_inventory: this.state.finishing_inventory,
                        prev_pending_orders: this.state.pending_orders,
                        prev_ready_orders: this.state.ready_orders,
                        finished_inventory,
                        finishing_inventory,
                        pending_orders,
                        ready_orders,
                        finished_inventory_most_purchased,
                        done_orders,
                        rejected_orders,
                        total_products,
                        total_pending_products,
                        total_rejected_products,
                        shop_visits,
                        products_visits,
                        loading: false,
                    });
                }).catch(error => {
                    console.log(error.response);
                    this.setState({
                        loading: false
                    });
                });
        } else {
            setStore({
                isAuth: false,
                user: null,
                loading: false
            });
            this.setState({
                loading: false
            });
        }
    }
    classes = this.props.classes;

    render(){
        let {
            finished_inventory,
            finishing_inventory,
            total_products,
            total_pending_products,
            total_rejected_products,
            shop_visits,
            products_visits,
            pending_orders,
            ready_orders,
            rejected_orders,
            done_orders,
            loading,
            open
        } = this.state;
        return (
            <Grid container spacing={2} direction="row" justify="center" alignItems="center">

                <Grid item xs={12} sm={6} md={3}>
                    <Grid container  style={{backgroundColor: "#fff",minHeight:195,alignContent:'flex-start',paddingBottom:0,position:"relative"}} direction="row" justify="center" className={this.classes.GridAsaPaperBaby}>
                        {
                            (pending_orders > 0 || ready_orders > 0) && <span className="ripple"></span>
                        }
                        <Grid item xs={11}>
                            <SubTitle style={{display:"flex",justifyContent:"space-between",alignItems:'center'}} align="left">
                                {Translate.manageOrders}
                                <Button
                                    size="small"
                                    color="secondary"
                                    variant="contained"
                                    component={Link}
                                    to={'/shop-orders'}
                                >
                                    {Translate.viewDetails}
                                </Button>
                            </SubTitle>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid item xs={12}>
                                <List dense>
                                    <ListItem>
                                        <ListItemText
                                            primary={Translate.pending_orders}
                                        />
                                        <ListItemSecondaryAction>
                                            <strong>{pending_orders}</strong>
                                            <IconButton size="small" component={Link} to={'/shop-orders?status=pending'}>
                                                <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary={Translate.ready_orders}
                                        />
                                        <ListItemSecondaryAction>
                                            <strong>{ready_orders}</strong>
                                            <IconButton size="small" component={Link} to={'/shop-orders?status=ready'}>
                                                <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary={Translate.done_orders}
                                        />
                                        <ListItemSecondaryAction>
                                            <strong>{done_orders}</strong>
                                            <IconButton size="small" component={Link} to={'/shop-orders?status=done'}>
                                                <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary={Translate.rejected_orders}
                                        />
                                        <ListItemSecondaryAction>
                                            <strong>{rejected_orders}</strong>
                                            <IconButton size="small" component={Link} to={'/shop-orders?status=rejected'}>
                                                <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Grid container  style={{backgroundColor: "#fff",minHeight:195,alignContent:'flex-start',paddingBottom:0,position:"relative"}} direction="row"  justify="center" className={this.classes.GridAsaPaperBaby}>
                        {
                            (finished_inventory > 0 || finishing_inventory > 0) && <span className="ripple"></span>
                        }
                        <Grid item xs={11}>
                            <SubTitle style={{display:"flex",justifyContent:"space-between",alignItems:'center'}} align="left">
                                {Translate.manageInventory}
                                <Button
                                    size="small"
                                    color="secondary"
                                    variant="contained"
                                    component={Link}
                                    to={'/modify-pricing'}
                                >
                                    {Translate.viewDetails}
                                </Button>
                            </SubTitle>
                        </Grid>
                        <Grid item xs={12}>
                            <List dense>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.finished_inventory}
                                    />
                                    <ListItemSecondaryAction>
                                        {finished_inventory}
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.finishing_inventory}
                                    />
                                    <ListItemSecondaryAction>
                                        {finishing_inventory}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </List>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Grid container   style={{backgroundColor: "#fff",minHeight:195,alignContent:'flex-start',paddingBottom:0}} direction="row"  justify="center" className={this.classes.GridAsaPaperBaby}>
                        <Grid item xs={11}>
                            <SubTitle style={{display:"flex",justifyContent:"space-between",alignItems:'center'}} align="left">
                                {Translate.manageBookStore}
                                <Button
                                    size="small"
                                    color="secondary"
                                    variant="contained"
                                    component={Link}
                                    to={'/my-products'}
                                >
                                    {Translate.viewDetails}
                                </Button>
                                </SubTitle>
                        </Grid>
                        <Grid item xs={12}>
                            <List dense>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.total_products}
                                    />
                                    <ListItemSecondaryAction>
                                        {total_products}
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.total_pending_products}
                                    />
                                    <ListItemSecondaryAction>
                                        {total_pending_products}
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.total_rejected_products}
                                    />
                                    <ListItemSecondaryAction>
                                        {total_rejected_products}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </List>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Grid style={{backgroundColor: "#fff",minHeight:195,alignContent:'flex-start',paddingBottom:0}} container   direction="row" justify="center" className={this.classes.GridAsaPaperBaby}>
                        <Grid item xs={11}>
                            <SubTitle style={{display:"flex",justifyContent:"space-between",alignItems:'center'}} align="left">
                                {Translate.visits}
                                </SubTitle>
                        </Grid>
                        <Grid item xs={12}>
                            <List dense>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.shop_visits}
                                    />
                                    <ListItemSecondaryAction>
                                        {shop_visits}
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={Translate.products_visits}
                                    />
                                    <ListItemSecondaryAction>
                                        {products_visits}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </List>
                        </Grid>
                    </Grid>
                </Grid>
                <Dialog open={open} onClose={() => this.setState({open:false})}>
                    <DialogContent>
                        <Typography>{Translate.activateSound}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({open:false})}
                            size="small"
                            color="primary"
                            variant="contained"
                        >
                            {Translate.activate}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        );
    }
}

export default withStyles(Styles)(SellerAnalyticsShort);